export const IDS = {
  // Landing
  landingRoot: "landing-root",
  landingCta: "landing-cta-start",
  landingPrimaryCta: "landing-hero-start-button",
  landingBrand: "brand-mark",

  // Intake
  intakeRoot: "invited-intake-root",
  statusBanner: "status-banner",
  stepProgress: "step-progress",
  backToOverview: "review-how-it-works-link",
  heroHeading: "hero-heading",
  howItWorks: "how-it-works",
  manualCallout: "manual-first-callout",
  feeCallout: "fee-callout",

  // Form
  form: "discovery-form",
  linkedinInput: "linkedin-input",
  websiteInput: "website-input",
  emailInput: "report-email-input",
  ackCheckbox: "acknowledgement-checkbox",
  submitButton: "submit-button",
  linkedinError: "linkedin-error",
  websiteError: "website-error",
  emailError: "email-error",
  ackError: "acknowledgement-error",

  // Confirmation
  confirmationRoot: "confirmation-root",
  confirmationEmail: "confirmation-report-email",
  confirmationRef: "confirmation-reference",
  returnButton: "return-to-katlas-button",

  // Footer / info
  footer: "site-footer",
  privacyLink: "footer-privacy-link",
  termsLink: "footer-terms-link",
  contactLink: "footer-contact-link",

  // Operator
  operatorRoot: "operator-root",
  operatorTokenInput: "operator-token-input",
  operatorLoadButton: "operator-load-button",
  operatorTable: "operator-table",
};
